import { Heading } from '@athena/forge';
import MutedText from './MutedText';
import { useMemo, useState } from 'react';
import { useEventBus } from '../../hooks/useEventBus';
import withEventHelper from './EventHelper';

export type FontSize = 'xsmall'| 'small' | 'default' | 'large'| 'xlarge'| 'xxlarge';
export type FontColor = 'default'| 'muted';
export type FontWeight = 'light' | 'regular' | 'semibold' | 'bold';

export interface HeaderPropsType {
  oktaHeader?: JQuery;
  oktaSubtitle?: JQuery;
  description?: string;
  headerText?: string;
  fontSize?: FontSize;
  fontWeight?: FontWeight;
  fontColor?: FontColor;
}

function Header({
  oktaHeader,
  oktaSubtitle,
  headerText,
  description,
  fontSize = 'default',
  fontWeight = 'semibold',
  fontColor = 'default',
}: HeaderPropsType) {
  const [ descriptionValue, setDescriptionValue ] = useState(description ? description : oktaSubtitle?.text() ?? '');
  const [ headerTextValue, setHeaderTextValue ] = useState(headerText ? headerText : oktaHeader?.text() ?? '');
  const onUpdateDescription = useMemo(() => {
    return ({ headerDescription }: { headerDescription: string }) => {
      setDescriptionValue(headerDescription);
    };
  }, []);

  const onUpdateTitle = useMemo(() => {
    return ({ headerText }: { headerText: string }) => {
      setHeaderTextValue(headerText);
    };
  }, []);

  useEventBus({ eventName: 'update-header-description', onEvent: onUpdateDescription });
  useEventBus({ eventName: 'update-header-title', onEvent: onUpdateTitle });

  const descriptionElement = descriptionValue && <MutedText className={'fe_u_text-align--center fe_u_font-size--default'} text={descriptionValue} />;
  return (
    <div className="fe_u_text-align--center fe_u_margin--bottom-large fe_u_margin--top-small">
      <Heading
        className={`fe_u_margin--bottom-medium fe_u_font-size--${fontSize} fe_u_font-weight--${fontWeight} fe_u_color--${fontColor}`}
        headingDescription={descriptionElement}
        text={headerTextValue}
        variant="subsection"
        headingTag={oktaHeader?.length ? oktaHeader[0].localName : 'h3'}
      ></Heading>
    </div>
  );
}

Header.displayName = 'Header';
const HeaderWithEventHelper = withEventHelper(Header);
export default HeaderWithEventHelper;
